/** The `false_friends` list of a production's grade (JSON left open by the schema), read safely. */

import type { FalseFriendHit } from "@agencyos/api-client";

const KINDS = ["false_friend", "calque", "english"] as const;
const SEVERITIES = ["check", "error"] as const;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

const text = (value: unknown): string => (typeof value === "string" ? value : "");
const int = (value: unknown): number => (typeof value === "number" ? value : 0);

export function parseFalseFriends(value: unknown): FalseFriendHit[] {
  if (!Array.isArray(value)) return [];
  return value.filter(isRecord).map((hit) => {
    const kind = KINDS.find((k) => k === hit.kind) ?? "false_friend";
    const severity = SEVERITIES.find((s) => s === hit.severity) ?? "check";
    return {
      id: text(hit.id),
      kind,
      severity,
      excerpt: text(hit.excerpt),
      start: int(hit.start),
      end: int(hit.end),
      french: text(hit.french),
      english: text(hit.english),
      meaning: text(hit.meaning),
      correct: text(hit.correct),
      example: text(hit.example),
    };
  });
}
